var _circle, _ellipse, _ellipse2, _circle2, _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLogoColor = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 109,
    height: 32,
    viewBox: "0 0 109 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "url(#paint0_radial_1095_6042)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.087,
    cy: 16.0248,
    rx: 13.3665,
    ry: 13.3913,
    fill: "url(#paint1_radial_1095_6042)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.7267,
    cy: 16,
    rx: 10.0124,
    ry: 9.98758,
    fill: "url(#paint2_radial_1095_6042)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.0994,
    cy: 16.025,
    r: 5.24224,
    fill: "url(#paint3_radial_1095_6042)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M93.8662 22.5778L90.2922 10.2183H92.5105L95.2219 20.6003L98.0565 10.2183H100.275L103.109 20.6003L105.821 10.2183H108.039L104.465 22.5778H101.877L99.1656 12.7643L96.4543 22.5778H93.8662Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M84.0145 22.949C79.9475 22.949 77.9756 19.9827 77.9756 16.3985C77.9756 12.8142 79.9475 9.8479 84.0145 9.8479C88.0815 9.8479 90.0534 12.8142 90.0534 16.3985C90.0534 19.9827 88.0815 22.949 84.0145 22.949ZM80.194 16.3985C80.194 19.9827 81.9194 21.4659 84.0145 21.4659C86.1096 21.4659 87.835 19.9827 87.835 16.3985C87.835 12.8142 86.1096 11.331 84.0145 11.331C81.9194 11.331 80.194 12.8142 80.194 16.3985Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M76.4902 22.5782H74.3951V6.51074H76.4902V22.5782Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M72.6629 22.5782H70.5677V6.51074H72.6629V22.5782Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M63.5545 22.949C59.4875 22.949 57.5156 19.9827 57.5156 16.3985C57.5156 12.8142 59.4875 9.8479 63.4313 9.8479C67.4983 9.8479 69.1004 12.9378 69.1004 15.9041V16.8928H59.734C59.8819 20.131 61.558 21.4659 63.5545 21.4659C65.1567 21.4659 66.5123 20.6007 66.8821 18.8704H68.9772C68.4842 21.2187 66.6356 22.949 63.5545 22.949ZM63.4313 11.331C61.5333 11.331 60.0544 12.5423 59.7833 15.4097H66.8821C66.8821 12.567 65.3046 11.331 63.4313 11.331Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2758 22.5782V6.51074H42.4801L47.6563 20.1062L52.8325 6.51074H56.0368V22.5782H53.9416V8.73546L48.6422 22.5782H46.6703L41.3709 8.73546V22.5782H39.2758Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1095_6042",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16 16) rotate(90) scale(16)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E122B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.252894,
    stopColor: "#131D52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.608015,
    stopColor: "#2750AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.927083,
    stopColor: "#A3EAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_1095_6042",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18.087 16.0248) rotate(90) scale(13.3913 13.3665)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F85F97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "#330E18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F00A38"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_1095_6042",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.7267 16) rotate(90) scale(9.98758 10.0124)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23164B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.489583,
    stopColor: "#15105D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.939782,
    stopColor: "#2D68C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_1095_6042",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12.0994 16.025) rotate(90) scale(5.24224)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB2354"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.557292,
    stopColor: "#CE2C65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF94CE"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLogoColor);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/logo_color.65f2f4e609e62930966d06e072ec35f0.svg";